import {MutationTree} from 'vuex';
import {SearchState} from '@/store/search/types';

export const mutations: MutationTree<SearchState> = {
    setQuery(state, payload: string) {
        state.query = payload;
    },
    setResult(state, payload) {
        state.filteredNodes  = Object.assign({}, state.filteredNodes, payload);
        // state.filteredNodes = payload;
    },
    setList(state, payload) {
        state.namespacesList = payload;
    },
};
